import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { SourceDocViewer } from '../../components/SourceDocViewer'
import { parsePositivePageNumber } from '../../lib/document-preview'

/**
 * Route target for resolved ingest-corpus citations. SourceDocViewer owns the
 * authenticated byte fetch and keeps object-storage locations out of links.
 */
export default function IngestSourceDocumentPage(): React.ReactElement {
  const navigate = useNavigate()
  const { jobId = '' } = useParams<{ jobId: string }>()
  const [searchParams] = useSearchParams()
  const sourceFile = searchParams.get('path')?.trim() ?? ''
  const sourcePage = parsePositivePageNumber(searchParams.get('page'))

  if (jobId.trim().length === 0 || sourceFile.length === 0) {
    return <Navigate to="/ingest" replace />
  }

  return (
    <SourceDocViewer
      open
      onOpenChange={(open) => {
        if (!open) navigate(-1)
      }}
      jobId={jobId}
      sourceFile={sourceFile}
      sourcePage={sourcePage}
    />
  )
}
